export default {
	title: '终端类型管理',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		name: '终端名称',
		mode: '通信模式',
		placeholder: {
			name: '请输入终端名称',
			mode: '请选择通信模式'
		}
	},
	table: {
		id: 'ID',
		name: '终端类型名称',
		icon: '图标',
		mode: '通讯模式',
		channels: '通道数',
		sysEig: '特征值',
		sysWave: '波形',
		orgId: '所属机构'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		name: '名称',
		icon: '图标',
		mode: '通讯模式',
		channels: '通道数',
		characters: '特征值功能码',
		topic: 'mqtt-topic',
		accelerate: '时域功能码',
		sysEig: '特征值',
		sysWave: '波形类型',
		orgId: '机构(诊断)',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			name: '请输入名称',
			icon: '请选择图标',
			mode: '请选择通讯模式',
			characters: '请输入特征值功能码',
			topic: '请输入 mqtt-topic',
			accelerate: '请输入时域功能码',
			orgId: '机构(诊断)'
		},
		options: {
			modeLabel: '标签 1'
		}
	}
}
